export default __webpack_public_path__ + "static/media/02d_fold-10.eda0b2db.mp4";